module.exports = __webpack_public_path__ + "static/img/sre-banner-m.5e47292.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sre-banner-m.png
// module id = 2UCB
// module chunks = 0